// extracted by mini-css-extract-plugin
export default {"DateParagraph":"NotificationCard_DateParagraph__Rken+","IconDiv":"NotificationCard_IconDiv__cvKCQ","TextDiv":"NotificationCard_TextDiv__uHGym"};